/**
 * pdfmake pesa 2.7 MB y sus fuentes otros 0.8 MB: más de la mitad del bundle
 * inicial cuando se importaba arriba de los archivos. Aquí se descarga la
 * primera vez que alguien imprime un tiquete o exporta un PDF, y se reutiliza
 * después. Todos los generadores de PDF deben pasar por acá.
 */
let pdfMakePromise: Promise<any> | null = null;

export function loadPdfMake(): Promise<any> {
    if (!pdfMakePromise) {
        pdfMakePromise = Promise.all([
            import('pdfmake/build/pdfmake'),
            import('pdfmake/build/vfs_fonts'),
        ]).then(([pdfMakeModule, fontsModule]: any[]) => {
            const pdfMake = pdfMakeModule.default || pdfMakeModule;
            const fonts = fontsModule.default || fontsModule;
            pdfMake.vfs = fonts.pdfMake ? fonts.pdfMake.vfs : fonts.vfs;
            return pdfMake;
        }).catch(error => {
            // Si la descarga falló (sin conexión), el próximo intento vuelve a pedirla.
            pdfMakePromise = null;
            throw error;
        });
    }
    return pdfMakePromise;
}
